// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"a795eefacca19ed00adc","114":"e0d7a853ceb1ea6c10ee","115":"f11c94c45059fd9df055","162":"90dd35fb6a4d1931ced6"}[chunkId] + ".chunk.js";
};